import { TagColor } from '@equip.health/ui';

export enum RiskLevel {
  HIGH = 'high',
  MEDIUM = 'medium',
  LOW = 'low',
  MINIMUM = 'minimum',
  MILD = 'mild',
  MODERATE = 'moderate',
  MODERATELY_SEVERE = 'moderately-severe',
  SEVERE = 'severe',
  NONE = 'none',
  NOT_CALCULATED = 'not-calculated',
}

export const RiskLevelToTagColors: Record<RiskLevel, TagColor> = {
  [RiskLevel.LOW]: TagColor.green,
  [RiskLevel.MINIMUM]: TagColor.green,
  [RiskLevel.MILD]: TagColor.marigold,
  [RiskLevel.MEDIUM]: TagColor.orange,
  [RiskLevel.MODERATE]: TagColor.orange,
  [RiskLevel.MODERATELY_SEVERE]: TagColor.brown,
  [RiskLevel.HIGH]: TagColor.red,
  [RiskLevel.SEVERE]: TagColor.red,
  [RiskLevel.NONE]: TagColor.gray,
  [RiskLevel.NOT_CALCULATED]: TagColor.lightGray,
};

export const RiskLevelToLabel: Record<RiskLevel, string> = {
  [RiskLevel.LOW]: 'Low',
  [RiskLevel.MINIMUM]: 'Minimal',
  [RiskLevel.MILD]: 'Mild',
  [RiskLevel.MEDIUM]: 'Medium',
  [RiskLevel.MODERATE]: 'Moderate',
  [RiskLevel.MODERATELY_SEVERE]: 'Moderately Severe',
  [RiskLevel.HIGH]: 'High',
  [RiskLevel.SEVERE]: 'Severe',
  [RiskLevel.NONE]: 'None',
  [RiskLevel.NOT_CALCULATED]: 'Risk not calculated',
};

export const RiskLevelToShortLabel: Record<RiskLevel, string> = {
  [RiskLevel.LOW]: 'L',
  [RiskLevel.MINIMUM]: 'Min',
  [RiskLevel.MILD]: 'Mild',
  [RiskLevel.MEDIUM]: 'M',
  [RiskLevel.MODERATE]: 'Mod',
  [RiskLevel.MODERATELY_SEVERE]: 'Mod Sev',
  [RiskLevel.HIGH]: 'H',
  [RiskLevel.SEVERE]: 'Sev',
  [RiskLevel.NONE]: 'None',
  [RiskLevel.NOT_CALCULATED]: 'RNC',
};
